const SESSION_EXPIRED_KEY = 'saya.sessionExpired';
const SESSION_RETURN_TO_KEY = 'saya.sessionReturnTo';

function requestURL(input: RequestInfo | URL): URL | null {
  try {
    const value = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    return new URL(value, window.location.origin);
  } catch {
    return null;
  }
}

function isProtectedAPIRequest(input: RequestInfo | URL): boolean {
  const url = requestURL(input);
  return !!url
    && url.origin === window.location.origin
    && url.pathname.startsWith('/api/')
    && url.pathname !== '/api/logout';
}

function safeRoute(hash: string): string | null {
  if (!hash.startsWith('#/')) return null;
  const route = hash.slice(1);
  return route === '/login' ? null : route;
}

export function rememberExpiredSession(currentHash: string): void {
  sessionStorage.setItem(SESSION_EXPIRED_KEY, 'true');
  const route = safeRoute(currentHash);
  if (route) sessionStorage.setItem(SESSION_RETURN_TO_KEY, route);
}

export function consumeSessionExpiredNotice(): boolean {
  const expired = sessionStorage.getItem(SESSION_EXPIRED_KEY) === 'true';
  sessionStorage.removeItem(SESSION_EXPIRED_KEY);
  return expired;
}

export function consumeSessionReturnTo(): string {
  const route = sessionStorage.getItem(SESSION_RETURN_TO_KEY);
  sessionStorage.removeItem(SESSION_RETURN_TO_KEY);
  return route?.startsWith('/') && route !== '/login' ? route : '/';
}

export function clearSessionNavigation(): void {
  sessionStorage.removeItem(SESSION_EXPIRED_KEY);
  sessionStorage.removeItem(SESSION_RETURN_TO_KEY);
}

/** Install once at the authenticated app shell to catch expired API sessions. */
export function installSessionExpiryInterceptor(onExpired: () => void): () => void {
  const originalFetch = globalThis.fetch;
  let handled = false;
  const interceptedFetch: typeof fetch = async (input, init) => {
    const response = init === undefined ? await originalFetch(input) : await originalFetch(input, init);
    if (!handled && response.status === 401 && isProtectedAPIRequest(input)) {
      handled = true;
      onExpired();
    }
    return response;
  };
  globalThis.fetch = interceptedFetch;
  return () => {
    if (globalThis.fetch === interceptedFetch) globalThis.fetch = originalFetch;
  };
}
